import toast from "react-hot-toast";
import * as api from "../Api";
export const createOutstandingCredit = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Submitting credit outstandings..");
    const { data } = await api.createCredits(postData);
    dispatch({ type: "CREATE_OUTSTANDING_CREDIT", payload: data });
    toast.remove(creatingId);
    toast.success("Credit outstandings successfully submitted");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.message);
  }
};
export const updateOutstandingCredit = (id, postData) => async (dispatch) => {
  let updatingId;
  try {
    updatingId = toast.loading("Saving changes...");
    const { data } = await api.updateCredits(id, postData);
    dispatch({ type: "UPDATE_CREDIT_OUTSTANDING_NEW", payload: data });
    toast.remove(updatingId);
    toast.success("Changes saved successfully");
  } catch (error) {
    toast.remove(updatingId);
    toast.error(error.message);
  }
};
